export enum EAdsTabs {
    Text,
    Product,
}
